import { useEffect } from "@wordpress/element";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { TextField } from "vino/core/forms";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "vino/core";
import { Address } from "vino/components/cart-checkout/Checkout";
import {
	ContactSchema,
	contactDefaultValues,
} from "vino/components/cart-checkout/models";
import {
	setCustomer,
	setShippingAddress,
	setShippingAddressId,
} from "store/vino/subscriptionSlice";

const ShippingAddress = ({ onNext, onBack }) => {
	const dispatch = useDispatch();
	const customer = useSelector(({ vino }) => vino.subscription.customer);
	const user = useSelector(({ auth }) => auth.user);
	const { isUserLoaded, data } = user;
	const methods = useForm({
		mode: "onChange",
		defaultValues: contactDefaultValues,
		resolver: yupResolver(ContactSchema),
	});
	const { handleSubmit, setValue, reset } = methods;

	useEffect(() => {
		if (customer) {
			reset(customer);
		}
	}, [reset, customer]);

	useEffect(() => {
		if (!customer && isUserLoaded) {
			setValue("email", data.email);
			setValue("address.phone", data.phone);
		} else {
			setValue("addNewAddress", true);
		}
	}, [customer, user]);

	const handleAddressChange = (address) => {
		setValue("address", address);
		dispatch(setShippingAddressId(address.id));
	};

	const handleLoginNavigation = () => {
		location.href = "/login";
	};

	const onSubmit = ({ email, address, addNewAddress }) => {
		if (!isUserLoaded) {
			dispatch(
				setCustomer({
					firstName: address.firstName,
					lastName: address.lastName,
					email: email,
				})
			);
		}
		if (addNewAddress) {
			dispatch(setShippingAddress(address));
		}
		onNext();
	};

	return (
		<Paper className="w-full rounded-20 shadow">
			<FormProvider {...methods}>
				<form
					noValidate
					className="flex flex-col w-full"
					onSubmit={handleSubmit(onSubmit)}
				>
					<div className="p-20">
						<div className="flex justify-between mb-10">
							<Typography className="text-16 font-medium">Contact</Typography>

							{!isUserLoaded && (
								<button onClick={handleLoginNavigation}>
									Login / Register
								</button>
							)}
						</div>
						<div className="w-full">
							{!isUserLoaded && (
								<TextField
									name="email"
									label="Email"
									required
									fullWidth
									autoFocus
								/>
							)}

							{isUserLoaded && <Typography>{data.email}</Typography>}
						</div>
					</div>
					<div className="w-full px-20">
						<Address title="Shipping Address" onChange={handleAddressChange} />
						<div className="flex justify-between w-full mb-20">
							<Button onClick={onBack}>
								<i className="fa-solid fa-angle-left mr-5"></i> Back
							</Button>
							<Button type="submit">
								Next <i className="fa-solid fa-angle-right ml-5"></i>
							</Button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Paper>
	);
};

export default ShippingAddress;
